import { ApexAnnotations, ApexChart, ApexDataLabels, ApexFill, ApexStroke, ApexTitleSubtitle, ApexXAxis, ApexYAxis } from 'ng-apexcharts';

export class Chart{
    series: any;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    dataLabels: ApexDataLabels;
    title: ApexTitleSubtitle;
    subtitle : ApexTitleSubtitle;
    plotOptions: any;
    yaxis: ApexYAxis;
    fill : ApexFill;
    annotations : ApexAnnotations;
    colors : string[];
  toolbar: any;
}
